import User from "./User";

export type Lesson = {
  id: string;
  url?: string;
  created_at: number;
  updated_at: number;
  state: LessonState;
  owner?: User;
  approver?: User;
  learned: string;
  headline: string;
  summary?: string;
  mitigation?: string;
  causes: Cause[];
  frequency_score?: number;
  impact_score?: number;
  recurrence_score?: number;
  origin?: string;
  comments?: number;
};

export enum LessonState {
  draft,
  review,
  approved,
  rejected
}

export type Cause = {
  issue: string;
  category: Category;
}

export type Category = {
  id: string;
  name: string;
  causes?: number;
  scores?: any;
}
